import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";

export default function TeacherLogin() {
  const { teacher, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (teacher) return <Navigate to="/ogretmen/havuzlar" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/ogretmen/havuzlar");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 gap-12 items-center px-5 sm:px-12 lg:px-24 py-10 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -left-40 h-[640px] w-[640px] rounded-full bg-[radial-gradient(circle,rgba(34,197,94,0.22),transparent_65%)]" />
      <section className="relative space-y-6 fade-in" data-testid="login-hero">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white" data-testid="back-home-link">
          <ArrowLeft className="h-4 w-4" /> Oyun koduna dön
        </Link>
        <Logo />
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.02]">Öğretmen<br />kontrol <span className="neon-text-green">odası</span></h1>
        <p className="text-slate-300 text-base sm:text-lg max-w-md">Soru havuzlarını yönet, oyunu başlat, sınıfın nabzını canlı takip et.</p>
        <div className="flex items-center gap-4 pt-4" data-testid="login-credit">
          <div className="leading-tight">
            <p className="font-display text-lg font-semibold text-white">Furkan Buyrukbilen</p>
            <a href="mailto:hi@furkan.agency" className="inline-flex items-center gap-1.5 text-sm text-[#FACC15] hover:text-[#FDE047] transition-colors duration-150" data-testid="login-credit-email">
              <Mail className="h-3.5 w-3.5" />hi@furkan.agency
            </a>
          </div>
        </div>
      </section>
      <div className="relative w-full max-w-md lg:justify-self-end fade-in">
        <form onSubmit={submit} className="panel p-6 sm:p-8 space-y-5" data-testid="teacher-login-form">
          <h2 className="font-display text-3xl font-bold">Giriş yap</h2>
          <div className="space-y-2">
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 text-base rounded-2xl bg-[#0B0F16]" data-testid="login-email-input" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Şifre</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12 text-base rounded-2xl bg-[#0B0F16]" data-testid="login-password-input" required />
          </div>
          {error && <p className="text-red-400 font-semibold" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full h-14 text-lg" data-testid="login-submit-button">
            Giriş
          </Button>
          <p className="text-sm text-slate-400 text-center">Aktivasyon kodun var mı? <Link to="/ogretmen/kayit" className="text-[#FACC15] hover:text-[#FDE047] font-semibold" data-testid="register-link">Kayıt ol</Link></p>
        </form>
      </div>
    </div>
  );
}
